export function getConsultationIdCheck(state = {}) {
  const idCheck = state.idCheck || {};
  return idCheck.data || {};
}
